"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _queryList = _interopRequireDefault(require("@/components/queryList"));
var _methods = require("@/components/Store/SalesKPIRecord/methods");
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var curDateTree = (0, _methods.getCurDateTree)(); // 获取当前时间相关 月份、季度、年份
var _default = exports.default = {
  components: {
    QueryList: _queryList.default
  },
  data: function data() {
    return {
      pageName: "SRIntegralReport",
      searchQuery: {
        type: "1",
        startMonth: curDateTree.month,
        endMonth: curDateTree.month,
        srEmpNo: "",
        srEmpName: "",
        asmEmpName: "",
        rsmEmpName: ""
      },
      apiModule: "kpiSet",
      urlModule: "REPORT"
    };
  },
  computed: {
    domData: function domData() {
      return {
        monthRange: {
          label: this.$t("sfe.SRIntegralReport.month"),
          type: "monthrange",
          valueKey: 'monthRange',
          valueFormat: "yyyyMM",
          inputType: 'daterange',
          pickerOptions: {
            disabledDate: function disabledDate(time) {
              var now = new Date();
              var currentMonth = now.getMonth();
              var currentYear = now.getFullYear();
              var minDate = new Date(currentYear - 2, currentMonth + 1, 1);
              var maxDate = new Date(currentYear, currentMonth + 1, 0);
              return time.getTime() > maxDate || time.getTime() < minDate;
            }
          },
          keyList: ['startMonth', 'endMonth']
        },
        srEmpNo: {
          label: this.$t("sfe.SRIntegralReport.srEmpNo"),
          valueKey: "srEmpNo"
        },
        srEmpName: {
          label: this.$t("sfe.SRIntegralReport.srEmpName"),
          valueKey: "srEmpName"
        },
        asmEmpName: {
          label: this.$t("sfe.SRIntegralReport.asmEmpName"),
          valueKey: "asmEmpName"
        },
        rsmEmpName: {
          label: this.$t("sfe.SRIntegralReport.rsmEmpName"),
          valueKey: "rsmEmpName"
        }
      };
    },
    tableButtons: function tableButtons() {
      return {
        export: {
          fileName: this.$t("sfe.route.srintegralreport"),
          apiUrl: "/protected/report/common/kpi/integralReport/export"
        }
      };
    },
    tableDom: function tableDom() {
      return {
        rsmEmpName: {
          label: this.$t("sfe.SRIntegralReport.rsmEmpName")
        },
        asmEmpName: {
          label: this.$t("sfe.SRIntegralReport.asmEmpName")
        },
        srEmpNo: {
          label: this.$t("sfe.SRIntegralReport.srEmpNo")
        },
        srEmpName: {
          label: this.$t("sfe.SRIntegralReport.srEmpName")
        },
        month: {
          label: this.$t("sfe.SRIntegralReport.month")
        },
        integralQty: {
          label: this.$t("sfe.SRIntegralReport.integralQty"),
          isCommasNumber: true
        },
        quarterTargetIntegralQty: {
          label: this.$t("sfe.SRIntegralReport.quarterTargetIntegralQty"),
          isCommasNumber: true
        },
        actualActiveStoreQty: {
          label: this.$t("sfe.SRIntegralReport.actualActiveStoreQty"),
          isCommasNumber: true
        },
        quarterTargetActiveStoreQty: {
          label: this.$t("sfe.SRIntegralReport.quarterTargetActiveStoreQty"),
          isCommasNumber: true
        }
      };
    },
    listApi: function listApi() {
      return {
        apiUrl: "/protected/report/common/kpi/integralReport/list"
      };
    }
  }
};